<template>
  <b-card class="questionnaire_short_item">
    <b-row class="v3_color_black_knight font_size_1000rem">
      <b-col class="d-flex align-items-center">
        <i class="mdi mdi-text-box-check-outline mr-2 font_size_1250rem" />
        {{questionnaireTitle}}
      </b-col>
      <b-col class="d-flex align-items-center">
        Study Period: {{ questionnaireStartDate }} -
        {{ questionnaireClosedDate }}
      </b-col>
      <b-col class="d-flex align-items-center">
        Random: Disabled
      </b-col>
      <b-col
          class="d-flex align-items-center justify-content-center">
        <b-button
            variant="v3_teal_outline"
            :to="`/user/filters/${questionnaire.id}`"
        >
          View Data
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

export default {
  name: 'QuestionnaireShortItem',
  props: {
    questionnaire: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  computed: {
    questionnaireTitle: function () {
      return this.questionnaire
        ? `${this.questionnaire.period} ${this.questionnaire.title}`
        : 'Study Insights';
    },
    questionnaireStartDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.start_date).format('MMM D, YYYY')
        : '';
    },
    questionnaireClosedDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.end_date).format('MMM D, YYYY')
        : '';
    },
    isSurveyStartDate: function () {
      return (
        this.questionnaire &&
        this.questionnaire.survey &&
        this.questionnaire.survey.created
      );
    },
    surveyStartDate: function () {
      return this.isSurveyStartDate
        ? this.$dayjs(this.questionnaire.survey.created).format('MMM D, YYYY')
        : null;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../../sass/v3.scss';
  .questionnaire_short_item {
    border: 1px solid rgba($v3_color_teal, .3);
    border-radius: 0;
    margin-bottom: 20px;
    .card-body {
      padding: 15px 20px;
    }
  }
</style>
